import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { IvyTransaction } from './transactions-api.service';

const HOST = environment.serverUrl;
const IVY_API_URL = HOST + '/ivy/plugs';

export interface IvyPlug {
  id: string;
  ocellId: string;
  status?: string;
  version?: string;
  lastTransactionId?: string;
  lastHeartbeat?: Date;
}

export interface IvyLastPlugInfo {
  plug: IvyPlug;
  lastTransaction?: IvyTransaction;
}

export interface RelayStateIndicatorValues {
  relay_state?: number;
  energyConsumedInKwh?: number;
}

export interface RelayStateIndicator {
  Timestamp: string;
  Values: RelayStateIndicatorValues;
}

export interface RelayState {
  SensorId: string;
  Indicators: RelayStateIndicator[];
}

export interface IvyCheckResult {
  isReady: boolean;
  checks: {
    callToOcellApiSucceeded: boolean;
    ocellFoundPlug: boolean;
    hasPlugSentRecentInfo: boolean;
  };
  debugInfo?: {
    fetchPlugErrorType?: string;
    fetchPlugErrorMessage?: string;
    relayState?: number;
    lastTimePlugSentInfo?: string;
  };
}

function reviveIvyLastPlugInfo(info: IvyLastPlugInfo): IvyLastPlugInfo {
  if (info.plug?.lastHeartbeat) {
    info.plug.lastHeartbeat = new Date(info.plug.lastHeartbeat);
  }
  return info;
}

@Injectable({ providedIn: 'root' })
export class ChargepointsIvyApiService {

  constructor(private http: HttpClient) { }

  public getPlugInfo(ocellPlugId: string): Observable<IvyLastPlugInfo> {
    return this.http.get<IvyLastPlugInfo>(`${IVY_API_URL}/${ocellPlugId}`).pipe(
      map(info => reviveIvyLastPlugInfo(info))
    );
  }

  public getRelayState(ocellPlugId: string): Observable<RelayState[]> {
    return this.http.get<RelayState[]>(`${IVY_API_URL}/${ocellPlugId}/relay-state`);
  }

  public checkConnectivity(ocellPlugId: string, testStartTime: Date): Observable<IvyCheckResult> {
    const params = new HttpParams().set('testStartTime', testStartTime.toISOString());
    return this.http.get<IvyCheckResult>(`${IVY_API_URL}/ocell-api/${ocellPlugId}/status`, { params });
  }
}
